import useSWR from 'swr';
import getEcgByID from '../services/ecg';

// Busca o laudo de ECG pelo código (mesmo padrão do useHolter)
export default function useEcg(id) {
  return useSWR(id ? ['ecg', id] : null, () => getEcgByID(id));
}
